var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ContactUs"}},[_c('div',{attrs:{"id":"ContactUs_box1"}}),_c('div',{staticClass:"ContactUs_box",attrs:{"id":"ContactUs_box2"}},[_c('div',{staticClass:"indexTitle"},[_vm._v("联系我们")]),_c('ContactUs_box2_inner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }